import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Plx from 'react-plx';
import useWindowPositioning from 'hooks/useWindowPositioning';
import Counter from 'components/Counter';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'Roboto Slab',
    fontWeight: '200',
    color: '#808080',
    userSelect: 'none',
  },
  counterWrapper: {
    display: 'inline-flex',
    marginRight: '1rem',
    color: '#0f487e',
    textAlign: 'right',
    justifyContent: 'flex-end',
  },
  highlight: {
    color: '#0f487e',
  },
}));

const HeadlineOne = ({ height = '550px', totalTransactionsSubmitted = 0, quarter, year }) => {
  const { windowDimensions, elementRef } = useWindowPositioning();
  const classes = useStyles();

  return (
    <>
      <div
        ref={elementRef}
        style={{
          height,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Plx
          data-testid="headline-panel"
          className={classes.headline}
          parallaxData={[
            {
              start: windowDimensions.animationStart + 500,
              end: windowDimensions.animationEnd + 200,
              easing: 'ease-in',
              properties: [
                {
                  startValue: 0,
                  endValue: 1,
                  property: 'opacity',
                },
              ],
            },
            // {
            //   start: windowDimensions.animationExitStart,
            //   end: windowDimensions.animationExitEnd - 400,
            //   easing: 'ease-in',
            //   properties: [
            //     {
            //       startValue: 1,
            //       endValue: 0,
            //       property: 'opacity',
            //     },
            //   ],
            // },
          ]}
          style={{
            position: 'absolute',
            width: '100%',
            height,
            zIndex: 100,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            opacity: 0,
          }}
        >
          <div className={`${classes.title} headline-title`}>
            <div className={`${classes.counterWrapper} counter-wrapper`}>
              <Counter value={totalTransactionsSubmitted} prefix="" suffix="" duration={1.5} />
            </div>
            <span className={classes.highlight}>transactions</span> were submitted in{' '}
            <span className={classes.highlight}>
              Q{quarter} {year}
            </span>
          </div>
        </Plx>
      </div>
    </>
  );
};

export default HeadlineOne;
